import React, { Fragment, useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { ModalContext } from "../../../../../../modal/ModalContext";
import { ChangeRegimenModal } from "./ChangeRegimenModal";

export const TaxpayerInformation = React.memo(
  ({ regimeSatCode, taxpayer, year, month, isOld }) => {
    const { handleModal } = useContext(ModalContext);

    const [regime, setRegime] = useState(null);
    const [activities, setActivity] = useState([]);
    const [idAct, setIdAct] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
      if (Object.keys(taxpayer).length !== 0) {
        const regime = taxpayer.regimes.find(
          (e) => e.satCode === regimeSatCode
        );

        setActivity(taxpayer.profileRegimes);
        setRegime(regime);
      }
    }, [regimeSatCode, taxpayer]);
    if (isOld) {
      return (
        <div className="col-md-12">
          <strong>Datos del contribuyente</strong> <br />
          <strong>Nombre contribuyente:</strong> {taxpayer.businessName} <br />
          <strong>RFC contribuyente:</strong> {taxpayer.rfc} <br />
          {regime && (
            <Fragment>
              <strong>Regimen:</strong> {regime.satCode} - {regime.officialName}{" "}
              <br />
            </Fragment>
          )}
          {
            <Fragment>
              <strong>
                Actividad(es):{" "}
                {activities.map((actividad) => (
                  <span key={actividad.id}>
                    {actividad.activities.map((activity, index) => (
                      <span
                        className="d-flex row justify-content-start pl-3"
                        key={index}
                      >
                        <span style={{ fontWeight: "normal" }}>
                          {activity.id} -{" "}
                        </span>
                        <span style={{ fontWeight: "normal" }}>
                          {" "}
                          {activity.description}
                        </span>
                        {index < actividad.activities.length - 1 ? (
                          <span style={{ fontWeight: "normal" }}>, </span>
                        ) : null}
                      </span>
                    ))}
                  </span>
                ))}
              </strong>
            </Fragment>
          }
          <Fragment>
            <button
              className="btn btn-sm btn-primary float-right ml-3"
              onClick={() =>
                handleModal(
                  <ChangeRegimenModal
                    taxpayer={taxpayer}
                    year={year}
                    month={month}
                  />
                )
              }
            >
              Cambiar regimenes
            </button>
          </Fragment>
              
        </div>
      );
    }
    return (
      <div className="table-responsive">
        <table
          className="table table-bordered table-sm mb-0"
          style={{ tableLayout: "auto", whiteSpace: "nowrap" }}
        >
          <thead className="thead-light">
            <tr>
              <th className="align-middle text-center" colSpan={2}>
                Datos del contribuyente
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="font-weight-bold">Nombre contribuyente</td>
              <td>{taxpayer.businessName}</td>
            </tr>
            <tr>
              <td className="font-weight-bold">RFC contribuyente</td>
              <td>{taxpayer.rfc}</td>
            </tr>
            <tr>
              <td className="font-weight-bold">Estado CIEC</td>
              <td>
                {taxpayer.mensajeCiec && (
                  <span
                    className={
                      `badge ` +
                      (taxpayer.mensajeCiec === "CIEC Válida"
                        ? "badge-success"
                        : taxpayer.mensajeCiec === "CIEC Sin Validar"
                        ? "badge-warning"
                        : "badge-danger")
                    }
                    style={{ fontSize: "1em", padding: "0.5em 1em" }}
                  >
                    {taxpayer.mensajeCiec}
                  </span>
                )}
              </td>
            </tr>
            {regime && (
              <tr>
                <td className="font-weight-bold">Régimen</td>
                <td>
                  {regime.satCode} - {regime.officialName}
                </td>
              </tr>
            )}
            <tr>
              <td className="font-weight-bold">Actividad(es)</td>
              <td>
                {activities.map((actividad) => (
                  <span key={actividad.id}>
                    {actividad.activities.map((activity, index) => (
                      <span key={index}>
                        {activity.id} - {activity.description}
                        {index < actividad.activities.length - 1 ? ", " : ""}
                      </span>
                    ))}
                    <br />
                  </span>
                ))}
              </td>
            </tr>
            <tr>
              <td colSpan={2} className="text-right">
                <button
                  className="btn btn-sm btn-primary"
                  onClick={() =>
                    handleModal(
                      <ChangeRegimenModal
                        taxpayer={taxpayer}
                        year={year}
                        month={month}
                      />
                    )
                  }
                >
                  Cambiar regimenes
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
);
